function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { useEffect } from 'react';
/**
 * Helper to trap focus within a certain component,
 * which is useful for canvas menu lists or modals
 */
export default function useTrapFocus(options) {
  var ref = options.ref,
    _options$isActive = options.isActive,
    isActive = _options$isActive === void 0 ? false : _options$isActive;
  useEffect(function () {
    function onKeyDown(e) {
      if (ref.current && isActive) {
        var _getFocusableElements = getFocusableElements(ref.current),
          first = _getFocusableElements.first,
          last = _getFocusableElements.last;
        var isTabPressed = e.key === 'Tab';
        if (!isTabPressed) {
          return;
        }
        if (e.shiftKey && document.activeElement === first) {
          if (last) last.focus();
          e.preventDefault();
          return;
        }
        if (!e.shiftKey && document.activeElement === last) {
          if (first) first.focus();
          e.preventDefault();
        }
      }
    }
    if (ref.current) {
      ref.current.addEventListener('keydown', onKeyDown);
    }
    return function () {
      if (ref.current) {
        ref.current.removeEventListener('keydown', onKeyDown);
      }
    };
  }, [ref, isActive]);
  function getFocusableElements(element) {
    var focusableElementTags = ['a[href]', 'area[href]', 'button', 'input', 'textarea', 'select', 'details', '[tabindex]:not([tabindex="-1"])'];
    var focusableElements = _toConsumableArray(element.querySelectorAll(focusableElementTags.join(', '))).filter(function (el) {
      return !el.hasAttribute('disabled') && !el.hasAttribute('aria-hidden');
    });
    return {
      focusableElements: focusableElements,
      first: focusableElements.length ? focusableElements[0] : null,
      last: focusableElements.length ? focusableElements[focusableElements.length - 1] : null
    };
  }
}